import React from 'react';
import { useIntl } from "react-intl";
import { LabelKeyValueItem } from '@/model';
import { useAgentId, useModal, usePageParam } from "@/hook";
import { usePaginatedAutocompletes } from "@/query/autocomplete";
import Button from "@/component/Button";
import PaginationBar from "@/component/PaginationBar";
import { TypeSearchbar } from '@/component/input';
import { AddIcon } from "@/assets/svgs/icons";

import AutocompleteTable from "./component/AutocompleteTable";
import AutocompleteCreateModal, { AUTOCOMPLETE_CREATE_MODAL_ID } from "./component/AutocompleteCreateModal";


const AUTOCOMPLETE_PAGE_SIZE = 15;

const SEARCH_TYPE_OPTIONS: LabelKeyValueItem[] = [
    { labelKey: "i08034", value: "name" },
    { labelKey: "i08033", value: "autocomplete_keyword" },
];

export interface AutocompletePageParam {
    page: number;
    size: number;
    searchKeyword?: string;
    searchType: "autocomplete_keyword" | "name";
}

const AutocompleteView: React.FC = () => {
    const intl = useIntl();
    const agentId = useAgentId();
    const modal = useModal();

    const { param, set: setParam } = usePageParam<AutocompletePageParam>({
        page: 0,
        size: AUTOCOMPLETE_PAGE_SIZE,
        searchType: "name",
    });

    const { data: autocompletePage } = usePaginatedAutocompletes(
        agentId,
        param?.page,
        param?.size,
        param?.searchKeyword,
        param?.searchType,
    );

    return (<>
        <AutocompleteCreateModal />

        <div className="agent-content-layout flex flex-col gap-3">
            <div className="search-bar-container w-md-page">
                <TypeSearchbar width={680}
                               searchTypes={SEARCH_TYPE_OPTIONS}
                               onSearch={(query, option) => setParam({ searchKeyword: query, searchType: option.value })}
                />

                <div className="search-bar-container-btn-group">
                    <Button variant="text"
                            onClick={() => modal.open(AUTOCOMPLETE_CREATE_MODAL_ID)}
                    >
                        <AddIcon className="size-3.5" />
                        {intl.formatMessage({ id: "i08006" })}
                    </Button>
                </div>
            </div>
            <div className="table-pagination-container w-md-page h-full">
                <AutocompleteTable page={autocompletePage}
                                   pageParam={param}
                />
                <PaginationBar pageData={autocompletePage}
                               onClickPage={page => setParam({ page })}
                />
            </div>
        </div>
    </>);
};

export default AutocompleteView;
